export default (theme) => ({
  root: {
    paddingBottom: 40,
  },

  // ── Profile header ──────────────────────────────────────────
  profileHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '28px 32px',
    marginBottom: 24,
    borderRadius: 8,
    gap: 24,
  },
  avatar: {
    width: 72,
    height: 72,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 28,
    fontWeight: 700,
    flexShrink: 0,
    letterSpacing: 1,
    marginRight: 16,
  },
  profileMeta: {
    flex: 1,
    minWidth: 0,
  },
  agentName: {
    fontSize: '1.5rem',
    fontWeight: 700,
    lineHeight: 1.2,
    marginBottom: 4,
    color: theme.palette.text.primary,
  },
  agentEmail: {
    color: theme.palette.text.secondary,
    fontSize: '0.9rem',
    marginBottom: 10,
  },
  headerChips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },
  chip: {
    fontSize: '0.75rem',
    height: 26,
  },
  chipVerified: {
    backgroundColor: '#e8f5e9',
    color: '#2e7d32',
    fontSize: '0.75rem',
    height: 26,
  },
  chipUnverified: {
    backgroundColor: '#fff3e0',
    color: '#e65100',
    fontSize: '0.75rem',
    height: 26,
  },
  chipSubscribed: {
    backgroundColor: '#e8f5e9',
    color: '#2e7d32',
    fontSize: '0.75rem',
    height: 26,
    fontWeight: 600,
  },
  chipUnsubscribed: {
    backgroundColor: '#f5f5f5',
    color: '#757575',
    fontSize: '0.75rem',
    height: 26,
    fontWeight: 600,
  },
  chipBrokerage: {
    backgroundColor: theme.palette.primary.light,
    color: '#fff',
    fontSize: '0.75rem',
    height: 26,
  },

  // ── Card grid ──────────────────────────────────────────
  cardGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 20,
    marginBottom: 20,
    [theme.breakpoints ? theme.breakpoints.down('sm') : '@media (max-width:600px)']: {
      gridTemplateColumns: '1fr',
    },
  },
  card: {
    borderRadius: 8,
    overflow: 'hidden',
    marginBottom: 20,
  },
  cardFull: {
    borderRadius: 8,
    overflow: 'hidden',
    marginBottom: 20,
  },
  cardHeader: {
    padding: '16px 24px 12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  cardTitle: {
    fontWeight: 700,
    fontSize: '0.8125rem',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    color: theme.palette.text.secondary,
  },
  cardBody: {
    padding: '0 24px 20px',
  },

  // ── Info rows ──────────────────────────────────────────
  infoRow: {
    display: 'flex',
    alignItems: 'baseline',
    padding: '9px 0',
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  infoLabel: {
    width: 140,
    flexShrink: 0,
    fontSize: '0.8rem',
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
  infoValue: {
    flex: 1,
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
    fontWeight: 400,
    wordBreak: 'break-word',
  },

  // ── Subscription display ──────────────────────────────────────────
  subscriptionStats: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 0,
  },
  subscriptionStat: {
    padding: '16px 24px',
    borderRight: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderRight: 'none',
    },
  },
  subscriptionStatLabel: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    fontWeight: 500,
    marginBottom: 6,
  },
  subscriptionStatValue: {
    fontSize: '1rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  noSubscription: {
    padding: '20px 24px',
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    fontStyle: 'italic',
  },

  // ── Edit sections ──────────────────────────────────────────
  editCardHeader: {
    padding: '16px 24px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 4,
  },
  editCardTitle: {
    fontWeight: 700,
    fontSize: '0.8125rem',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    color: theme.palette.text.secondary,
  },
  editGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '0 24px',
    padding: '8px 24px 0',
  },
  editGridWide: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '0 24px',
    padding: '8px 24px 0',
  },
  editFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 12,
    padding: '16px 24px 20px',
  },
  checkboxRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px 24px 0',
  },
  divider: {
    margin: '4px 0 0',
  },
});
